import { FC } from "react";

import { SearchConditionGroupResponse } from "@/web-client";
import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import CheckboxLink from "@/components/CheckboxLink";

interface SearchConditionGroupCheckboxProps {
  searchConditionGroup: SearchConditionGroupResponse;
  selectedIds: number[];
  queryController: SearchQueryParameterController<ProductSearchQueryParameter>;
}

export const SearchConditionGroupCheckbox: FC<
  SearchConditionGroupCheckboxProps
> = ({
  searchConditionGroup: { values },
  selectedIds,
  queryController,
}): JSX.Element => {
  return (
    <ul className="grid text-sm gap-4">
      {values.map((value) => (
        <li key={value.id}>
          <CheckboxLink
            checked={selectedIds.includes(value.id)}
            href={queryController.toPath({
              search_condition_value_ids: selectedIds.includes(value.id)
                ? selectedIds.filter((v) => v !== value.id).join(",")
                : [...selectedIds, value.id.toString()].join(","),
            })}
          >
            {value.label}
          </CheckboxLink>
        </li>
      ))}
    </ul>
  );
};
